var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import JobFactory from '../job/JobFactory';
import ThreadPool from '../thread/ThreadPool';
import KeldaError from './KeldaError';
import WorkModuleLoader from '../work/WorkModuleLoader';
import LocalWorkModule from '../work/LocalWorkModule';
var defaultOptions = {
    threadPoolDepth: 1
};
var Kelda = /** @class */ (function () {
    function Kelda(_a) {
        var threadPoolDepth = (_a === void 0 ? defaultOptions : _a).threadPoolDepth;
        this.cache = {};
        this.threadPool = new ThreadPool(threadPoolDepth);
    }
    Kelda.prototype.orderWork = function (source) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var work, job, result, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getWorkModule(source)];
                    case 1:
                        work = _a.sent();
                        job = JobFactory.getJob(work).with(args);
                        return [4 /*yield*/, this.threadPool.schedule(job)];
                    case 2:
                        result = _a.sent();
                        return [2 /*return*/, result];
                    case 3:
                        e_1 = _a.sent();
                        this.toKeldaError(e_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Kelda.prototype.load = function (_a) {
        var url = _a.url, exportName = _a.exportName;
        return __awaiter(this, void 0, void 0, function () {
            var loader, id;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        loader = new WorkModuleLoader(url, exportName);
                        return [4 /*yield*/, loader.get()];
                    case 1:
                        _b.sent();
                        id = Object.keys(this.cache).length + 1;
                        this.cache[id] = loader;
                        return [2 /*return*/, id];
                }
            });
        });
    };
    Kelda.prototype.lazy = function (_a) {
        var url = _a.url, exportName = _a.exportName;
        var id = Object.keys(this.cache).length + 1;
        this.cache[id] = new WorkModuleLoader(url, exportName);
        return id;
    };
    Kelda.prototype.getWorkModule = function (source) {
        return __awaiter(this, void 0, void 0, function () {
            var url, exportName, loader;
            return __generator(this, function (_a) {
                switch (typeof source) {
                    case 'function': {
                        return [2 /*return*/, new LocalWorkModule(source)];
                    }
                    case 'object': {
                        url = source.url, exportName = source.exportName;
                        return [2 /*return*/, new WorkModuleLoader(url, exportName).get()];
                    }
                    case 'number': {
                        loader = this.cache[source];
                        if (!loader)
                            throw new KeldaError("Invalid work id: '" + source + "'");
                        return [2 /*return*/, loader.get()];
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    Kelda.prototype.toKeldaError = function (e) {
        var message = e.message || 'Something went wrong while processing work';
        throw new KeldaError(message);
    };
    return Kelda;
}());
export default Kelda;
